'use client';

import { c as _c } from "react/compiler-runtime";
import type { PayloadAdminBarProps, PayloadMeUser } from 'payload-admin-bar';
import { useSelectedLayoutSegments } from 'next/navigation';
import { PayloadAdminBar } from 'payload-admin-bar';
import React, { useState } from 'react';
import { cn } from '~/lib/utils';
const collectionLabels = {
  pages: {
    plural: 'Pages',
    singular: 'Page'
  },
  posts: {
    plural: 'Posts',
    singular: 'Post'
  },
  projects: {
    plural: 'Projects',
    singular: 'Project'
  }
};
const Title: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span>Dashboard</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const AdminBar: React.FC<{
  adminBarProps?: PayloadAdminBarProps;
}> = props => {
  const $ = _c(19);
  let t0;
  if ($[0] !== props) {
    t0 = props || {};
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    adminBarProps
  } = t0;
  const segments = useSelectedLayoutSegments();
  const [show, setShow] = useState(false);
  const collection = segments?.[1] && segments[1] in collectionLabels ? segments[1] as CollectionKey : "pages";
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = user => {
      setShow(!!user?.id);
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onAuthChange = t1;
  const t2 = !show;
  let t3;
  if ($[3] !== show || $[4] !== t2) {
    t3 = cn("bg-black py-2 text-white", {
      block: show,
      hidden: t2
    });
    $[3] = show;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      controls: "font-medium text-white",
      logo: "text-white",
      user: "text-white"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = collectionLabels[collection]?.plural || "Pages";
  const t6 = collectionLabels[collection]?.singular || "Page";
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = {
      plural: t5,
      singular: t6
    };
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Title />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      backgroundColor: "transparent",
      padding: 0,
      position: "relative",
      zIndex: "unset"
    };
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== adminBarProps || $[13] !== collection || $[14] !== t7) {
    t10 = <div className="container"><PayloadAdminBar {...adminBarProps} className="py-2 text-white" classNames={t4} cmsURL={process.env.NEXT_PUBLIC_SERVER_URL} collection={collection} collectionLabels={t7} logo={t8} onAuthChange={onAuthChange} style={t9} /></div>;
    $[12] = adminBarProps;
    $[13] = collection;
    $[14] = t7;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t3) {
    t11 = <div className={t3}>{t10}</div>;
    $[16] = t10;
    $[17] = t3;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
};